module.exports = "/_next/static/images/check-on-7e913a6a.png";